import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { Providers } from './providers'
import './style.css'

const SPA_BASENAME = (import.meta.env.BASE_URL || '/').replace(/\/$/, '') || '/'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <BrowserRouter basename={SPA_BASENAME}>
        <App />
      </BrowserRouter>
    </Providers>
  </StrictMode>,
)
